//accesses defsites.json, returns a pair of arrays

export function getCreatorDefsites() {
    const defSites = require('../assets/defSites.json');
    let sitesWithListName = [];
    defSites.forEach(element => {
        if (element.listName){
            if(!element.creatorPath) {
                throw new TypeError(`Element with listname ${element.listName} doesn't have creatorPath specified. Check assets/defsites.json`)
            }
            if(!element.pageTranslationKey) {
                throw new TypeError(`Element with listname ${element.listName} doesn't have pageTranslationKey specified. Check assets/defsites.json`)
            }
            sitesWithListName.push(element);
        }
    });
    return sitesWithListName;
}



// WEBPACK FOOTER //
// ./src/utils/divideDefsitesByOrigin.js